<script setup lang="ts">
import { scrollToTop } from '@/utils/util'
defineProps<{
  activeClass: string
}>()
</script>

<template>
  <RouterLink
    to="/me"
    replace
    :aria-label="$t('me.title')"
    :active-class="activeClass"
    flex
    flex-col
    text-second
    items-center
    place-content-center
    h-full
    flex-1
    class="coarse-pointer:select-none"
    @click="scrollToTop">
    <div i-weui:me-outlined text-6.5 />
    <div text-xs mt-0.5>{{ $t('me.title') }}</div>
  </RouterLink>
</template>
